/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { accessTokenRequest } from "./authCodePolicies";
import { getMsalInstance, initializeMsalInstance } from "./msalHelpers";
import logger from "../logger";
import { clearUserContext } from "../../telemetryService";

const logOut = async () => {
  const msalInstance = getMsalInstance();
  const currentAccounts = msalInstance.getAllAccounts();
  const { accountId } = currentAccounts[0];
  const logoutRequest = {
    account: msalInstance.getAccountByHomeId(accountId),
  };
  clearUserContext();
  await msalInstance.logoutRedirect(logoutRequest);
};

const acquireTokenRedirect = () => {
  const msalInstance = getMsalInstance();
  msalInstance.acquireTokenRedirect(accessTokenRequest);
};

const getApiToken = async () => {
  const msalInstance = getMsalInstance();

  try {
    const { accessToken } = await msalInstance.acquireTokenSilent(
      accessTokenRequest
    );

    if (!accessToken) {
      logger.error("Access token returned from B2C is empty");
    }

    return accessToken;
  } catch (error) {
    logger.error(error);
  }
};

const run = (callback) => {
  initializeMsalInstance(callback);
};

export { acquireTokenRedirect, getApiToken, logOut, run };
